export default __webpack_public_path__ + "static/scan-your-qr-41e604e2fb10ddf125ef6c074e8effc3.gif";